module.exports = __webpack_public_path__ + "media/images/version_merge/qr_code/modal/rule2-e5674059ffce8225cce66c4b796b4ff3.png";